import PropTypes from 'prop-types';
import classNames from 'classnames';

import ModuleListItems from './components/ModuleListItems';
import { categorizeRoutes } from './utilities/helpers';

import styles from './_index.module.scss';

const ModuleList = ({ routes, show_favorites: showFavorites, type }) => {
  const {
    allRoutes,
    favoriteRoutes,
    specialtySurveyRoutes = [],
    standardSurveyRoutes = [],
  } = categorizeRoutes(routes, showFavorites);

  return (
    <div>
      {type === 'survey' && (
        <>
          {standardSurveyRoutes.length > 0 && (
            <div className={styles['module-list']}>
              <h4>Standard</h4>
              <ModuleListItems routes={standardSurveyRoutes} type={type} />
            </div>
          )}
          {specialtySurveyRoutes.length > 0 && (
            <div
              className={classNames(
                styles['module-list'],
                standardSurveyRoutes.length > 0 && styles['has-border-top']
              )}
            >
              <h4>Specialty Surveys</h4>
              <ModuleListItems routes={specialtySurveyRoutes} type={type} />
            </div>
          )}
        </>
      )}

      {type === 'report' && (
        <div>
          {showFavorites && favoriteRoutes.length > 0 && (
            <div className={classNames(styles['module-list'], styles['favorite'])}>
              <h4>Favorites</h4>
              <ModuleListItems routes={favoriteRoutes} type={type} />
            </div>
          )}
          <ModuleListItems routes={allRoutes} type={type} />
        </div>
      )}
    </div>
  );
};

ModuleList.propTypes = {
  routes: PropTypes.array.isRequired,
  show_favorites: PropTypes.bool,
  type: PropTypes.oneOf(['report', 'survey']).isRequired,
};

export default ModuleList;
